export type TenantUserRole = "SuperModerator" | "Moderator" | "Sale";

export class CreateTenantUserDto {
  userFirstName?: string;
  userLastName?: string;
  userEmail?: string;
  userRole?: TenantUserRole;
}
